import loadable from '@loadable/component';
import React from 'react'
const DashboardComponent = loadable(
  () => import("../../components/Dashboard")
);
const AdminDashboard = () => {
  return (
    <>
      <DashboardComponent />
    </>
  )
}

export default AdminDashboard
